import Persona from './Persona';

export default Persona;